<template>
  <div class="seach">
    <div class="download-center">
      <div class="download-center-box">
        <div class="download-center-title">
          Download Center
          <!-- 下载中心 -->
        </div>
        <div class="seach-box">
          <div class="seach-box-left">
            <i class="el-icon-search"></i>
            <!-- -->
            <el-input v-model="searchTetx" placeholder="Search for content you want to download "></el-input>
          </div>
          <div class="seach-button" @click="getSeach">search</div>
        </div>
      </div>
    </div>
    <div class="product">
      <div class="product-cont">
        <div class="product-box">
          <div class="download-box">
            <div class="download-box-left">
              <div class="" v-for="(item, index) in menuList" :key="index">
                <div class="download-box-left-title">{{ item.name }}</div>
                <div class="download-box-left-list">
                  <div class="left-list-item" v-for="(items, indexs) in item.childlist" :key="indexs"
                    :class="manualId == items.id ? 'cur' : ''" @click="getMenu(items)">
                    {{ items.name }}
                  </div>
                </div>
              </div>

            </div>
            <div class="download-box-right">
              <div class="download-box-right-title">
                {{ title }}
              </div>
              <div class="right-list">
                <div class="right-list-item" v-for="(item, index) in list" :key="index"
                  @click="downloadEvt(item.about_file)">
                  <p class="right-list-item-text">
                    {{ item.title }}
                  </p>
                  <img class="download-icon" src="../../static/image/download-icon.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product">
      <div class="product-cont">
        <div class="product-box">
          <div class="block pagination">
            <el-pagination background layout="total, prev, pager, next, jumper" :page-size="pageSize" :total="total"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import footerBotom from '@/components/footer.vue'
import { serviceCate, serviceList } from '@/request/api'
export default {
  components: {
    footerBotom
  },
  data() {
    return {
      menuList: [],
      manualId: null,
      list: [],
      searchTetx: "",
      total: 0,
      page: 1,
      pageSize: 10,
      title: ""
    }
  },
  created() {
    this.getMenuList()
  },
  mounted() {

  },
  methods: {
    getMenuList() {
      serviceCate().then(res => {
        if (res.code == 1) {
          let arr = []
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].id == 22) {
              arr.push(res.data[i])
            }
          }
          this.manualId = arr[0].childlist[0].id
          this.title = arr[0].childlist[0].name
          this.menuList = arr
          this.getList()
        }
      })
    },
    getMenu(item) {
      this.manualId = item.id
      this.title = item.name
      this.page = 1
      this.list = []
      this.getList()
    },
    getList() {
      serviceList({ page: this.page, size: this.pageSize, keyword: this.searchTetx, channel: this.manualId }).then(res => {
        if (res.code == 1) {
          this.total = res.data.total
          this.list = res.data.list[this.manualId]
        }
      })
    },
    getSeach() {
      this.page = 1
      this.list = []
      this.getList()
    },
    downloadEvt(url, fileName = '111') {
      const el = document.createElement('a');
      el.style.display = 'none';
      el.setAttribute('target', '_blank');
      /**
        * download的属性是HTML5新增的属性
        * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
        * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
        * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
        */
      fileName && el.setAttribute('download', fileName);
      el.href = url;
      document.body.appendChild(el);
      el.click();
      document.body.removeChild(el);
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.page = val
      this.list = []
      this.getList()

    },
  },
}
</script>
<style lang="scss" scoped>
.download-center-title {
  font-size: 36px;
  font-weight: bold;
  color: #333333;
}

.download-center {
  margin-top: 92px;
  height: 322px;
  width: 100%;
  background-image: url('../../static/image/seach.png');
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .download-center-box {
    width: 80%;

    text-align: center;
  }

  .seach-box {
    width: 80%;
    margin: 0 auto;
    margin-top: 35px;
    height: 75px;
    border-radius: 41px;
    border: 2px solid #999999;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .seach-box-left {
      padding: 0 44px;
      display: flex;
      align-items: center;
      width: calc(100% - 210px);

      >>>.el-input__inner {
        display: block;
        background: transparent !important;
        border: none !important;
        width: 90% !important;
        height: 100% !important;
      }
    }



    .seach-button {
      cursor: pointer;
      width: 209px;
      height: 75px;
      line-height: 75px;
      text-align: center;
      background: #DB2733;
      border-radius: 41px;
      font-size: 18px;

      font-weight: 400;
      color: #FFFFFF;
    }
  }
}


.download-box {
  display: flex;
  align-items: self-start;
  justify-content: space-between;

  .download-box-left {
    width: 371px;
    background: #F7F7F7;
    padding: 42px 26px;

    .download-box-left-title {
      padding-bottom: 36px;
      font-size: 22px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
      border-bottom: 1px solid #C8C8C8;
    }

    .download-box-left-list {
      margin-top: 35px;

      .left-list-item {
        cursor: pointer;
        font-size: 16px;

        color: #666666;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 34px;
      }

      .cur {
        color: #DB2733;
      }

      .left-list-item:hover {
        color: #DB2733;
      }
    }
  }

  .download-box-right {
    margin-left: 60px;
    width: calc(100% - 60px - 371px);

    .download-box-right-title {
      padding-bottom: 35px;
      font-size: 22px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
      border-bottom: 1px solid #C8C8C8;

    }

    .right-list-item {
      cursor: pointer;
      padding: 43px 0 34px 0;
      border-bottom: 1px solid #DFDFDF;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .right-list-item-text {
        font-size: 16px;

        color: #333333;
      }

      .download-icon {
        cursor: pointer;
        width: 18px;
        height: 18px;
      }
    }
  }
}



.pagination {
  display: flex;
  justify-content: center;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #DB2733;
    color: #FFFF !important;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #DB2733;
  }

  /deep/ .el-input__inner:focus {
    border-color: #DB2733 !important;
  }
}

@media screen and (max-width:767px) {
  .seach-box {
    width: 100% !important;
    height: 50px !important;

    .seach-box-left {
      width: calc(100% - 180px) !important;
    }

    .seach-button {
      width: 80px !important;
      line-height: 50px !important;
      height: 50px !important;
    }
  }

  .download-box {
    display: block !important;

    .download-box-left {
      width: calc(100% - 52px) !important;
    }

    .download-box-right {
      margin: 0 !important;
      width: 100% !important;
      margin-top: 30px !important;

      .right-list-item-text {
        max-width: 80%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/download.vue